export default __webpack_public_path__ + "static/media/product_landing.86063251.png";